import { configureStore } from "@reduxjs/toolkit";

import { siteConfigSlice } from "Common/Redux/siteConfig";

import { benAdminOpenEnrollmentSetupApi } from "./benAdminOpenEnrollmentSetup.api";

export const reducerSlices = {
  [siteConfigSlice.name]: siteConfigSlice.reducer,
  [benAdminOpenEnrollmentSetupApi.reducerPath]: benAdminOpenEnrollmentSetupApi.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(benAdminOpenEnrollmentSetupApi.middleware),
    preloadedState,
  });

  return store;
};
